import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=37fabca6&"
import script from "./CardComponent.vue?vue&type=script&lang=js&"
export * from "./CardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\webserver\\htdocs\\BancaSella_simplehero_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fabca6')) {
      api.createRecord('37fabca6', component.options)
    } else {
      api.reload('37fabca6', component.options)
    }
    module.hot.accept("./CardComponent.vue?vue&type=template&id=37fabca6&", function () {
      api.rerender('37fabca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CardComponent.vue"
export default component.exports